import { useQuery } from 'react-query';

import { LibraryPanelTemplate } from '@mpm-druid/types';
import api, { QueryConfig } from '@shared/api';

type GetCodePanelTemplateResponse = {
  id: string;
  workspaceId: string;
  owner: string;
  name: string;
  createdAt: string;
};

export async function getPanelLibraryTemplate({
  templateId,
  signal
}: {
  templateId: string;
  signal?: AbortSignal;
}) {
  const { data } = await api.get<GetCodePanelTemplateResponse>(
    `code-panels/mpm/templates/${templateId}`,
    { signal }
  );

  return {
    created_at: data.createdAt,
    created_by: data.owner,
    id: data.id,
    name: data.name,
    updated_at: data.createdAt
  };
}

export function usePanelLibraryTemplate<SelectData = LibraryPanelTemplate>(
  { templateId }: { templateId?: string },
  config?: QueryConfig<LibraryPanelTemplate, SelectData>
) {
  return useQuery(
    ['panel-library-template', { templateId }],
    context => {
      if (!templateId) {
        throw new Error('Template ID is required');
      }

      return getPanelLibraryTemplate({ templateId, signal: context.signal });
    },
    {
      retry: false,
      ...config,
      enabled: (config?.enabled ?? true) && !!templateId
    }
  );
}
